import { render } from "./newBill.vue?vue&type=template&id=0d68c047"
import script from "./newBill.vue?vue&type=script&lang=js"
export * from "./newBill.vue?vue&type=script&lang=js"

import "./newBill.vue?vue&type=style&index=0&id=0d68c047&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__